module.exports = __webpack_public_path__ + "static/media/nb_akademie_light-webfont.caeff28b.ttf";